export const environment = {
  PRODUCTION: false,
  API_URL: 'https://dev.api.assessment.wginb.com',
  SSO_API_URL: 'https://dev.api.sso.wginb.com',
  LOGIN_SSO_URL: 'https://dev.api.assessment.wginb.com/wgassessmentlogin/ssologin',
  MSAL_CONFIG: {
    clientId:"2e52c79e-026c-4a11-b3d3-4ca7fb2830ad",
    authority: "https://login.microsoftonline.com/ac313092-082d-44a3-9637-6a2e02b2a8ad",
    redirectUri: 'https://dev.portal.assessment.wginb.com',
    postLogoutRedirectUri: 'https://dev.portal.assessment.wginb.com'
  }
};
